module.exports = __webpack_public_path__ + "static/img/bg-function-2.1a952262.png";